<template>
<Toast/>
  <div class="row" v-if="messageLocal.id != null">
    <div class="col-4 lbl">
      <label>Clé :</label>
    </div>
    <div class="col-4">
      <InputText type="string" v-model="messageLocal.id" :disabled="true" />
    </div>
  </div>
  <div class="row">
    <div class="col-4 lbl">
      <label>Valeur :</label>
    </div>
    <div class="col-4">
      <TextArea rows="5" cols="50" type="string" v-model="messageLocal.message"/>
    </div>
  </div>
  <div class="row">
    <div class="col-4 lbl">
      <label>Niveau :</label>
    </div>
    <div class="col-4">
      <Dropdown
        v-model="messageLocal.niveau"
        :options="niveauLibelles"
        optionValue="valeur"
        optionLabel="texte"
        scrollHeight="205px"/>
    </div>
  </div>
  <div class="row">
    <div class="col-4 lbl">
      <label>Date de début :</label>
    </div>
    <div class="col-4">
      <InputText type="datetime-local" max="9999-12-31T23:59" v-model="messageLocal.dateDebut"/>
    </div>
  </div>
  <div class="row">
    <div class="col-4 lbl">
      <label>Date de fin :</label>
    </div>
    <div class="col-4">
      <InputText type="datetime-local" max="9999-12-31T23:59" v-model="messageLocal.dateFin"/>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <Button @click="sauvegarder"> Sauvegarder </Button>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer </Button>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['sauvegarder'],
  props: ['message'],
  data() {
    return {
      messageLocal: {...this.message},
      niveauLibelles: [{valeur: 1, texte: "Pop-Up + Message en rouge"}, {valeur: 2, texte: "Message en rouge"}, {valeur: 3, texte: "Message en bleu"}]
    }
  },
  methods : {
    sauvegarder() {
      if(this.messageLocal.message == null || this.messageLocal.niveau == null || this.messageLocal.dateDebut == null || this.messageLocal.dateFin == null){
        this.$toast.add({
          severity:'error',
          summary: 'Message utilisateur',
          detail:'Tous les champs doivent être remplis',
          life: 6000
        });
      }else {
        this.$emit('sauvegarder', this.messageLocal);
      }
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  }
}
</script>
